import { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Heading, Text } from './typography'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
  actionButtonVariant?: 'default' | 'form'
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  actionButtonVariant = 'default',
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('border rounded-lg', className)}>
      <div className="flex flex-col items-center justify-center py-12 px-4 text-center min-h-96">
        <div className="flex flex-col items-center">
          <div className="text-gray-400 mb-4">{icon}</div>
          <Heading variant="subsection-title" className="mb-2">
            {title}
          </Heading>
          <Text variant="muted" className="mb-4 max-w-sm">
            {description}
          </Text>
          {actionLabel && onAction && (
            <Button
              onClick={onAction}
              variant={actionButtonVariant === 'form' ? 'form' : 'default'}
            >
              {actionLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
